var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5 10C30.2239 10 30 10.2239 30 10.5C30 10.7761 30.2239 11 30.5 11H74.5C74.7761 11 75 10.7761 75 10.5C75 10.2239 74.7761 10 74.5 10H30.5ZM22 22.5C22 22.2239 22.2239 22 22.5 22H82.5C82.7761 22 83 22.2239 83 22.5C83 22.7761 82.7761 23 82.5 23H22.5C22.2239 23 22 22.7761 22 22.5ZM18.5 35C16.5109 35 14.6032 35.7902 13.1967 37.1967C11.7902 38.6032 11 40.5109 11 42.5V86.5C11 88.4891 11.7902 90.3968 13.1967 91.8033C14.6032 93.2098 16.5109 94 18.5 94H86.5C88.4891 94 90.3968 93.2098 91.8033 91.8033C93.2098 90.3968 94 88.4891 94 86.5V42.5C94 40.5109 93.2098 38.6032 91.8033 37.1967C90.3968 35.7902 88.4891 35 86.5 35H18.5ZM18.5 34C16.2457 34 14.0837 34.8955 12.4896 36.4896C10.8955 38.0837 10 40.2457 10 42.5V86.5C10 88.7543 10.8955 90.9164 12.4896 92.5104C14.0837 94.1045 16.2457 95 18.5 95H86.5C88.7543 95 90.9163 94.1045 92.5104 92.5104C94.1045 90.9164 95 88.7543 95 86.5V42.5C95 40.2457 94.1045 38.0837 92.5104 36.4896C90.9163 34.8955 88.7543 34 86.5 34H18.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.2576 54.0627C46.4166 53.9746 46.6109 53.9797 46.765 54.076L62.765 64.076C62.9112 64.1674 63 64.3276 63 64.5C63 64.6724 62.9112 64.8326 62.765 64.924L46.765 74.924C46.6109 75.0203 46.4166 75.0254 46.2576 74.9373C46.0986 74.8492 46 74.6818 46 74.5V54.5C46 54.3182 46.0986 54.1508 46.2576 54.0627ZM47 55.4021V73.5979L61.5566 64.5L47 55.4021Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgVideo105;